// Справочник валют для дропдауна добавления. Не весь ISO 4217 — только
// ходовые для путешествий, иначе список из ~180 кодов не найти глазами.
// Названия берутся из словаря ключом `currency.name.<код>`, символ — отсюда,
// руками его больше не вводят.
import type { Currency } from '../../types';

export interface CurrencyCatalogEntry {
  code: Currency;
  symbol: string;
}

export const CURRENCY_CATALOG: readonly CurrencyCatalogEntry[] = [
  { code: 'USD', symbol: '$' },
  { code: 'EUR', symbol: '€' },
  { code: 'GBP', symbol: '£' },
  { code: 'CHF', symbol: 'Fr.' },
  { code: 'JPY', symbol: '¥' },
  { code: 'CNY', symbol: 'CN¥' },
  { code: 'TRY', symbol: '₺' },
  { code: 'AED', symbol: 'AED' },
  { code: 'GEL', symbol: '₾' },
  { code: 'AMD', symbol: '֏' },
  { code: 'RUB', symbol: '₽' },
  { code: 'KZT', symbol: '₸' },
  { code: 'PLN', symbol: 'zł' },
  { code: 'CZK', symbol: 'Kč' },
  { code: 'HUF', symbol: 'Ft' },
  { code: 'RON', symbol: 'lei' },
  { code: 'BGN', symbol: 'лв' },
  { code: 'RSD', symbol: 'дин.' },
  { code: 'SEK', symbol: 'kr' },
  { code: 'NOK', symbol: 'kr' },
  { code: 'DKK', symbol: 'kr' },
  { code: 'ILS', symbol: '₪' },
  { code: 'THB', symbol: '฿' },
  { code: 'VND', symbol: '₫' },
  { code: 'INR', symbol: '₹' },
  { code: 'IDR', symbol: 'Rp' },
  { code: 'MYR', symbol: 'RM' },
  { code: 'SGD', symbol: 'S$' },
  { code: 'EGP', symbol: 'E£' },
  { code: 'MAD', symbol: 'DH' },
];

/** Символ по коду из справочника; '' — код не в списке (не должно случаться из select). */
export function catalogSymbol(code: Currency): string {
  return CURRENCY_CATALOG.find((c) => c.code === code)?.symbol ?? '';
}
